import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'home',
      component: ()=> import('@/pages/Home')
    }, {
      path: '/service',
      name: 'service',
      component: ()=> import('@/pages/service/Service')
    },{
      path:'/about',
      name:'about',
      component:()=> import('@/pages/about/About')
    },{
      path: '/info',
      name: 'Info',
      component: ()=> import('@/pages/service/Info')
    }, {
      path: '/contact',
      name: 'contact',
      component: ()=> import('@/pages/contact/Contact')
    }, {
      path: '/error',
      name: 'Error',
      component: ()=> import('@/pages/other/Error')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js